<template>
  <v-container fluid no-gutters class="mx-0 px-0 py-0 my-0">
    <v-row no-gutters class="mx-0 px-0 py-0 my-0">
      <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="#1b2f5a"
            @click="toTop"
            style="z-index: 10"
            aria-label="Επιστροφή στην κορυφή"
          >
            <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
      <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
          <v-img
              height="auto"
              width="100vw"
              contain 
              :src="require('@/assets/news.jpg')">
          </v-img>
      </v-col>
    </v-row>
    <v-row class="page-gutter mt-8 mb-6">
      <v-col
        v-for="article in articles"
        :key="article.id"
        cols="12"
        sm="6"
        lg="4"
        class="pa-3 align-self-stretch"
      >
        <article-card :article="article" />
      </v-col>
    </v-row>
    <v-row no-gutters class="mb-12 px-10">
        <v-col cols="12" align="center">
            <v-pagination
                v-if="lastPage > 1"
                v-model="page"
                :length="lastPage"
                :total-visible="$vuetify.breakpoint.mobile ? 5 : 7"
                @input="fetchArticles()"
            ></v-pagination>
        </v-col>
    </v-row>
    <paron-card-section/>
  </v-container>
</template>


<script>
  import restApi from "@/rest-api";
  import ParonCardSection from "../components/ParonCardSection.vue";
  import ArticleCard from "@/components/ArticleCard.vue";

  export default {
    components: { ParonCardSection, ArticleCard },
    data() {
        return {
            articles:[],
            fab: false,
            page: 1,
            lastPage: 1
        }
    },
    created() {
      this.fetchArticles();
    },
    methods: {
      fetchArticles() {
        var search = `/article/filtered?page=${this.page}&per_page=12`;
        restApi
        .get(search)
        .then(response => {
              this.articles = response.data
              this.lastPage = response.last_page
              this.toTop()
        })
        .catch((error) => {
            console.log(error);
        });
      },
      onScroll (e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset ||   e.target.scrollTop || 0
            this.fab = top > 20
      },
      toTop () {
        this.$vuetify.goTo(0)
      }
    }
  }
</script>
